import { BKJSideModal } from 'components/BKJSideModal';
import { useTranslation } from 'hooks/useTranslation';
import { FC, useMemo } from 'react';
import { usePositionsAllocationModalUIContext } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.ui.context';
import { PositionsAllocationModalDataProvider } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.data.context';
import { PositionsAllocationComponentMap } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.constants';
import { positionsAllocationModalRoutingService } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModalRouting.constants';

export const PositionsAllocationModalComponent: FC = () => {
  const { isOpen, positionsAllocationActiveModalView } = usePositionsAllocationModalUIContext();
  const { t } = useTranslation();

  const Component = useMemo(
    () => PositionsAllocationComponentMap[positionsAllocationActiveModalView],
    [positionsAllocationActiveModalView],
  );

  const modalHeader = {
    ApplyPositionView: t('location_settings:LOCATIONS_ALLOCATION'),
  };
  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={positionsAllocationModalRoutingService.close}
      headerComponent={modalHeader[positionsAllocationActiveModalView]}
    >
      {isOpen && (
        <PositionsAllocationModalDataProvider>
          <Component />
        </PositionsAllocationModalDataProvider>
      )}
    </BKJSideModal>
  );
};
